export default {
  100021: "请通过【数据服务】完善财务信息!"
}
